const fields = (group, entries) =>
  entries.map(([id, label]) => ({ id, label, group }));

export const LEAD_EXPORT_TAB_FIELDS = [
  ...fields("Details", [
    ["contact", "Contact"], ["title", "Title"], ["company_career_website", "Company Career Website"],
    ["salary_range", "Salary Range"], ["company_size", "Company Size"], ["industry", "Industry"],
    ["job_type", "Job Type / Workplace"], ["need_sponsorship", "Need Sponsorship"],
    ["hard_skills", "Hard Skills"], ["soft_skills", "Soft Skills"], ["description", "Description"],
    ["key_responsibilities", "Key Responsibilities"], ["qualifications", "Qualifications"],
  ]),
  ...fields("Stages", [["stage", "Stage"], ["stage_name", "Stage Name"], ["stage_updated_at", "Stage Updated"], ["pipeline_stage", "Pipeline Stage"]]),
  ...fields("Matches", [["match_score", "Match Score"], ["match_status", "Match Status"], ["matched_candidates", "Matched Candidates"], ["top_matches", "Top Matches"]]),
  ...fields("Activities", [["last_activity", "Last Activity"], ["activity_type", "Activity Type"], ["activity_notes", "Activity Notes"], ["next_activity_at", "Next Activity"]]),
];

export const JOB_EXPORT_TAB_FIELDS = [
  ...fields("Details", [["job_description", "Job Description"], ["requirements", "Requirements"], ["responsibilities", "Responsibilities"], ["salary_range", "Salary Range"], ["employment_type", "Employment Type"], ["work_arrangement", "Work Arrangement"], ["skills", "Skills"], ["benefits", "Benefits"]]),
  ...fields("Stages", [["stage", "Stage"], ["pipeline_stage", "Pipeline Stage"], ["stage_updated_at", "Stage Updated"]]),
  ...fields("Matches", [["match_score", "Match Score"], ["matched_candidates", "Matched Candidates"], ["top_matches", "Top Matches"]]),
  ...fields("Activities", [["last_activity", "Last Activity"], ["activity_type", "Activity Type"], ["activity_notes", "Activity Notes"]]),
];

export const COMPANY_EXPORT_TAB_FIELDS = [
  ...fields("Details", [["description", "Description"], ["industry", "Industry"], ["company_size", "Company Size"], ["funding_stage", "Funding Stage"], ["total_raised", "Total Raised"], ["technology_stack", "Technology Stack"], ["website", "Website"]]),
  ...fields("Stages", [["stage", "Stage"], ["stage_updated_at", "Stage Updated"]]),
  ...fields("Matches", [["match_score", "Match Score"], ["matched_candidates", "Matched Candidates"]]),
  ...fields("Activities", [["last_activity", "Last Activity"], ["activity_type", "Activity Type"], ["activity_notes", "Activity Notes"]]),
];

export const CANDIDATE_EXPORT_TAB_FIELDS = [
  ...fields("Details", [["summary", "Summary"], ["skills", "Skills"], ["hard_skills", "Hard Skills"], ["soft_skills", "Soft Skills"], ["experience", "Experience"], ["education", "Education"], ["salary_expectations", "Salary Expectations"], ["availability", "Availability"]]),
  ...fields("Stages", [["stage", "Stage"], ["stage_updated_at", "Stage Updated"]]),
  ...fields("Matches", [["match_score", "Match Score"], ["matched_jobs", "Matched Jobs"], ["top_matches", "Top Matches"]]),
  ...fields("Activities", [["last_activity", "Last Activity"], ["activity_type", "Activity Type"], ["activity_notes", "Activity Notes"]]),
];

export const CONTENT_EXPORT_TAB_FIELDS = [
  ...fields("Details", [["description", "Description"], ["body", "Content Body"], ["tags", "Tags"], ["source", "Source"], ["owner", "Owner"]]),
  ...fields("Activities", [["last_activity", "Last Activity"], ["activity_type", "Activity Type"], ["activity_notes", "Activity Notes"]]),
];

export const TEAM_EXPORT_TAB_FIELDS = [
  ...fields("Details", [["role", "Role"], ["department", "Department"], ["phone", "Phone"], ["location", "Location"], ["bio", "Bio"]]),
  ...fields("Activities", [["last_activity", "Last Activity"], ["activity_type", "Activity Type"]]),
];
